// Language utility functions for managing language preferences

// Supported languages
export const LANGUAGES = {
  ENGLISH: 'en',
  SINHALA: 'si',
  TAMIL: 'ta'
};

export const LANGUAGE_NAMES = {
  en: 'English',
  si: 'සිංහල',
  ta: 'தமிழ்'
};

// Default language
const DEFAULT_LANGUAGE = LANGUAGES.ENGLISH;

// LocalStorage key
const LANGUAGE_STORAGE_KEY = 'preferred_language';

/**
 * Get the current language from localStorage
 * @returns {string} Language code (en, si, ta)
 */
export const getCurrentLanguage = () => {
  try {
    const savedLanguage = localStorage.getItem(LANGUAGE_STORAGE_KEY);
    if (savedLanguage && Object.values(LANGUAGES).includes(savedLanguage)) {
      return savedLanguage;
    }
  } catch (error) {
    console.error('Error reading language from localStorage:', error);
  }
  return DEFAULT_LANGUAGE;
};

/**
 * Set the current language in localStorage
 * @param {string} language - Language code (en, si, ta)
 * @returns {boolean} Success status
 */
export const setCurrentLanguage = (language) => {
  try {
    if (!Object.values(LANGUAGES).includes(language)) {
      console.error('Invalid language code:', language);
      return false;
    }
    localStorage.setItem(LANGUAGE_STORAGE_KEY, language);
    return true;
  } catch (error) {
    console.error('Error saving language to localStorage:', error);
    return false;
  }
};

/**
 * Get language name for display
 * @param {string} languageCode - Language code (en, si, ta)
 * @returns {string} Display name
 */
export const getLanguageName = (languageCode) => {
  return LANGUAGE_NAMES[languageCode] || LANGUAGE_NAMES[DEFAULT_LANGUAGE];
};

/**
 * Validate if a language code is supported
 * @param {string} languageCode - Language code to validate
 * @returns {boolean} True if valid
 */
export const isValidLanguage = (languageCode) => {
  return Object.values(LANGUAGES).includes(languageCode);
};
